import { z } from 'zod'

import {
  HistoryDocumentType,
  HistoryType,
  HistoryChangeType,
} from '../constants/history'

/*
 * @deprecated TODO: use ActivityLog instead
 */
export const historySchema = z.object({
  // _id: z.string(),
  id: z.string(),
  created: z.date(),
  modified: z.date(),
  documentType: z.nativeEnum(HistoryDocumentType),
  documentId: z.string(),
  type: z.nativeEnum(HistoryType),
  changedByName: z.string(),
  changedById: z.string(),
  changedByEmail: z.string().nullish(),
  changedByProfileImage: z.string().nullish(),
  changes: z.array(
    z.object({
      type: z.nativeEnum(HistoryChangeType),
      keyPath: z.string(),
      arrayIndex: z.number().optional(),
      oldValue: z.any().optional(),
      newValue: z.any().optional(),
    })
  ),
  displayText: z.string().optional(),
})
